import { api } from './client';

export const getTrips = async (params = {}) => {
  const response = await api.get("/trips/", { params });
  return response.data;
};

export const getTripById = async (id) => {
  const response = await api.get(`/trips/${id}/`);
  return response.data;
};

export const getTripPassengers = async (tripId) => {
  const response = await api.get(`/trips/${tripId}/passengers/`);
  return response.data;
};

export const updatePassengerBoarding = async (tripId, passengerId, boardingStatus) => {
  const response = await api.patch(
    `/trips/${tripId}/passengers/${passengerId}/boarding/`,
    { boarding_status: boardingStatus }
  );
  return response.data;
};

export const getSeatsForTrip = async (tripId) => {
  const response = await api.get(`/trips/${tripId}/seats/`);
  return response.data;
};

export const patchTripSale = async (tripId, soldOut) => {
  const response = await api.patch(`/trips/${tripId}/sale/`, { sold_out: soldOut });
  return response.data;
};
